module.exports = "<div class=\"header\">\n  <div *ngIf=\"logo !== undefined\" [ngClass]=\"{'forceLogoMobile': forceLogoMobile}\" class=\"logo\">\n    <a [href]=\"logo.targetURL\" target=\"_blank\"><img [src]=\"logo.icon\"></a>\n    <h4>{{shop.name}}</h4>\n  </div>\n  <div class=\"catalog\">\n    <h2>{{catalog.name}}</h2>\n    <h4>{{catalog.date}}</h4>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cockehsu-header.component.html
// module id = ./src/app/cockehsu-header.component.html
// module chunks = main